module.exports = __webpack_public_path__ + "img/andrew-pena-big-bear-trees.9a9e3c4.jpg";